import React, { useEffect, useState } from "react";
import axios from "axios";
import { Button, Table } from "react-bootstrap";
import AddFeeTemplateModal from "../Modals/AddFeeTemplateModal";
import config from '../../../config';
import TemplateDetailModal from "../Modals/TemplateDetailModal";
import { useGrade } from "../../../context/GradeContext";


const FeeStructure = () => {
  const [templates, setTemplates] = useState([]);
  const [show, setShow] = useState(false);
  const [selected, setSelected] = useState(null);
  const [showDetail, setShowDetail] = useState(false);
  const { grade } = useGrade();

  const loadTemplates = async () => {
    const res = await axios.get(`${config.apiBaseUrl}/fees/fee_templates.php?action=list`);
    setTemplates(res.data);
  };

  useEffect(() => {
    loadTemplates();
  }, []);

  const getClassLabel = (id) => {
    const found = grade.find(g => String(g.value) === String(id));
    return found ? found.label : id;
  };

  return (
    <div className="container mt-4">
      <div className="d-flex justify-content-between mb-3">
        <h4>Fee Structure</h4>
        <Button onClick={() => setShow(true)}>+ Add Template</Button>
      </div>

      <Table bordered hover>
        <thead className="table-light">
          <tr>
            <th>Class</th>
            <th>Session</th>
            <th>Total Amount</th>
            <th>No. of Items</th>
          </tr>
        </thead>
        <tbody>
          {templates.map((t, i) => (
            <tr
                key={i}
                style={{ cursor: "pointer" }}
                onClick={() => {
                    setSelected(t);
                    setShowDetail(true);
                }}
                >
              <td>{getClassLabel(t.class_id)}</td>
              <td>{t.session}</td>
              <td>₹{t.total}</td>
              <td>{t.items}</td>
            </tr>
          ))}
        </tbody>
      </Table>

      <AddFeeTemplateModal
        show={show}
        onHide={() => setShow(false)}
        refresh={loadTemplates}
      />
      {/*View Template Detail*/}
      <TemplateDetailModal
        show={showDetail}
        onHide={() => setShowDetail(false)}
        template={selected}
      />

    </div>
  );
};

export default FeeStructure;
